import fetchWith403Redirect from './fetchWith403Redirect';
import { API_URL as API_BASE } from '../config/env';

const API_URL = `${API_BASE}/api/voucher-status-notes`;

export async function deleteVoucherStatusNote(id) {
  try {
    const res = await fetchWith403Redirect(`${API_URL}/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    if (!res.ok) {
      const errText = await res.text();
      console.error('Failed to delete note:', res.status, errText);
      throw new Error('Failed to delete note');
    }
    return res.json();
  } catch (err) {
    console.error('deleteVoucherStatusNote error:', err);
    throw err;
  }
}
export async function getAllVoucherStatusNotesForStudent(studentPk, externalStudentId = null) {
  try {
    const q = new URLSearchParams();
    q.set('student_id', String(studentPk));
    if (externalStudentId != null && String(externalStudentId).trim() !== '') {
      q.set('student_external_id', String(externalStudentId).trim());
    }
    const res = await fetchWith403Redirect(`${API_URL}?${q.toString()}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
    if (!res.ok) {
      const errText = await res.text();
      console.error('Failed to fetch notes:', res.status, errText);
      throw new Error('Failed to fetch notes');
    }
    return res.json();
  } catch (err) {
    console.error('getAllVoucherStatusNotesForStudent error:', err);
    throw err;
  }
}

export async function getVoucherStatusNotes(student_id, settlement_date_id) {
  try {
    const res = await fetchWith403Redirect(`${API_URL}?student_id=${student_id}&settlement_date_id=${settlement_date_id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
    if (!res.ok) {
      const errText = await res.text();
      console.error('Failed to fetch notes:', res.status, errText);
      throw new Error('Failed to fetch notes');
    }
    return res.json();
  } catch (err) {
    console.error('getVoucherStatusNotes error:', err);
    throw err;
  }
}

export async function addVoucherStatusNote({ student_id, settlement_date_id, note }) {
  try {
    const res = await fetchWith403Redirect(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ student_id, settlement_date_id, note })
    });
    if (!res.ok) {
      const errText = await res.text();
      console.error('Failed to add note:', res.status, errText);
      throw new Error('Failed to add note');
    }
    return res.json();
  } catch (err) {
    console.error('addVoucherStatusNote error:', err);
    throw err;
  }
}
